<!-- Inactive Image -->
@if (!visible && activityStatusId !== 2) {
    <img [src]="getInactiveURL()"
         class="status-img img-responsive float-end"
         [ngClass]="{ 'from-top': offsetFrom === 'top', 'from-bottom': offsetFrom === 'bottom' }"
         [ngStyle]="{ 'right': rightOffset + 'px', 'bottom': inactiveOffset }"
         helpTooltip
         [contentComponent]="helpContentComponent"
         [contentComponentValue]="dataValue">
}

<!-- Sold Image -->
@if (!visible && transaction && transaction.soldDate) {
    <img src="/images/sold.png"
         alt="Sold"
         class="sold-img img-responsive float-end"
         [ngClass]="{ 'from-top': offsetFrom === 'top', 'from-bottom': offsetFrom === 'bottom' }"
         [ngStyle]="{ 'right': rightOffset + 'px', 'top': soldOffset }"
         helpTooltip
         [tooltipText]="(transaction.soldDate ? (transaction.soldDate | date:'MM/dd/yyyy':'utc') : null)">
}
